import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth-service/auth.service';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent implements OnInit {

  constructor(public authService: AuthService) { }

  ngOnInit() {
    localStorage.setItem('firstConnection', 'false');
    //this.authService.paymentSuccessoff.next(true);
  }

}
